import { useMemo } from 'react';
import { useClientsWithCompaniesQuery } from '@/api/auth/queries';
import type { ClientWithCompanies } from '@/api/auth/interfaces';

/** Upper bound used by admin pickers that need every tenant at once (same as the users list filters). */
const ALL_TENANTS_LIMIT = 1000;

/**
 * All tenants with their companies for admin pickers, plus an id lookup.
 * Shares one cached query between the tenant/company pickers and the user tenant-access cards.
 * @param enabled - Set false to skip loading (e.g. while a modal is closed).
 */
export function useAllTenantsWithCompanies(enabled = true) {
  const query = useClientsWithCompaniesQuery({ page: 1, limit: ALL_TENANTS_LIMIT }, enabled);
  const tenants: ClientWithCompanies[] = useMemo(() => query.data?.clients ?? [], [query.data]);
  const tenantsById = useMemo(() => new Map(tenants.map((tenant) => [tenant.id, tenant])), [tenants]);

  return { tenants, tenantsById, isLoading: query.isLoading };
}
